import { Controller, Get } from '@nestjs/common';
import { AppService } from './app.service';
import { MysqlService } from './mysql/mysql.service';

@Controller()
export class AppController {
  constructor(private readonly appService: AppService,
    private readonly mysqlService: MysqlService
  ) {}

  @Get()
  getData() {
    return this.appService.getData();
  }

  @Get('health-mysql')
  async testDB() {
    return await this.mysqlService.testConnection();
  }
}
